'use client'

import { useMsal } from '@azure/msal-react'
import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { loginRequest } from 'authConfig'

const AccessDeninedImg = '/assets/AccessDenied.jpg'

export function AccessDenied() {
  const { instance } = useMsal()
  return (
    <section className='flex items-center h-full p-16  '>
      <div className='container flex flex-col items-center justify-center px-5 mx-auto my-8'>
        <img
          width='631'
          height='379'
          src={process.env.PUBLIC_URL + AccessDeninedImg}
          alt='Access Denied'
        />
        <div className='max-w-md text-center'>
          <Typography className='text-2xl font-semibold md:text-3xl'>
            Access Denied !!!
          </Typography>
          <p className='mt-4 mb-8 dark:text-gray-400'>
            Contact the website administrator to resolve.
          </p>
          <Button
            onClick={() => instance.loginRedirect(loginRequest)}
            variant='contained'
          >
            Back To Login
          </Button>
        </div>
      </div>
    </section>
  )
}
